angular.module('autorizzazioneSddLo.components', []).component('autorizzazioneSddLo', {
	templateUrl: 'ng/components/autorizzazioneSddLO/autorizzazioneSddLo.html',
	bindings: {
		raccoltaInfo: '=',
		ibanIsOk: '&',
		ibanIsNotOk: '&',
		model: '=',
		autorizzazione: '&',
		digital: "=",
		isM14: "=",
		isArc: "=",
    isLo:"="
	},
	controllerAs: 'autorizzazioneSddLOCtrl',
	controller: function autorizzazioneSddControllerLO(
		HttpService,
		$giuridicVersion,
		FactoryObj,
		$typeDomainService,
		$financialApiService,
		$portalService,
		$rootScope
	) {
		var self = this;
		//self.giuridicVersion = $giuridicVersion; 

		self.$onInit = function () {
			self.raccoltaInfo = self.raccoltaInfo || null;
      if(!self.isLo && self.digital) {
        self.raccoltaInfo = {
          autorizzazioneSDD: {
            iban: "",
            banca: {
            name: "",
            },
            ibanRadio: "",
          },
          };
          self.loading = {
          listaIban: false,
          };
          self.dropdown = {
          listaIban: [],
          listaIbanObj: [],
          listaBanche: [],
          };
      }
      if(self.isLo && self.digital){
        self.loading = {
          listaIban: false,
          };
          self.dropdown = {
          listaIban: [],
          listaIbanObj: [],
          listaBanche: [],
          };
      }
			self.warnings = {};
			self.getIbanDropdown();
			self.listBank();

			//commento per richiesta mantis n. 0014537
			// if (self.isM14) {
			// 	if (self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento) {
			// 		self.raccoltaInfo.autorizzazioneSDD = self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento;
			// 		return;
			// 	}
			// } else {
				if (!self.isArc && !self.isLo) {
					if (self.model.financialCustomer.metadata.autorizzazione) {
						self.raccoltaInfo.autorizzazioneSDD = self.model.financialCustomer.metadata.autorizzazione;
						return;
					}
				}
			//}
		}

		self.getIbanDropdown = function () {
			self.loading.listaIban = true;
			if (self.digital && !self.isLo) {
				$typeDomainService.getListIban(self.model.financialCustomer.metadata.riUserG, self.digital)
					.then(function (listAppNsilIban) {
						if (listAppNsilIban && listAppNsilIban.length > 0) {
							self.dropdown.listaIbanObj = listAppNsilIban;
							self.dropdown.listaIban = [];
							listAppNsilIban.forEach(function (el) {
								self.dropdown.listaIban.push(el.iban);
							});
						}
					})
					.catch(function (err) {
						console.log(err);
						self.dropdown.listaIban = [];
					})
					.finally(function () {
						console.log('getIbanDropdown finally');
						if (self.dropdown.listaIban &&
							self.dropdown.listaIban.length > 0) {
							self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
						} else {
							self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
						}
						self.loading.listaIban = false;
					})
			} else {
				$typeDomainService.getListIban(FactoryObj.selectedUserG && FactoryObj.selectedUserG.ndg)
					.then(function (listAppNsilIban) {
						if (listAppNsilIban && listAppNsilIban.length > 0) {
							self.dropdown.listaIbanObj = listAppNsilIban;
							self.dropdown.listaIban = [];
							listAppNsilIban.forEach(function (el) {
								self.dropdown.listaIban.push(el.iban);
							});
						}
					})
					.catch(function (err) {
						console.log(err);
						self.dropdown.listaIban = [];
					})
					.finally(function () {
						console.log('getIbanDropdown finally');
						if (self.dropdown.listaIban &&
							self.dropdown.listaIban.length > 0) {
							self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
						} else {
							self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
						}
						self.loading.listaIban = false;
					})
			}
		}

		self.getListaIban = function (search, ibanList) {
			if (ibanList.length) {
				var newIbanList = ibanList.slice();
				if (search && newIbanList.indexOf(search) === -1) {
					newIbanList.unshift(search);
				}
				return newIbanList;
			}
		}

		self.listBank = function () {
			$typeDomainService.getDomainSet('RI_DROPDOWN_DOMAINS', 'BANKS')
				.then(function (response) {
					self.dropdown.listaBanche = response.domainList;
					self.selectBank();
				})
		}

		self.selectBank = function () {
			self.warnings.iban = false;
			if (self.raccoltaInfo.autorizzazioneSDD.iban) {
				self.raccoltaInfo.autorizzazioneSDD.iban = self.raccoltaInfo.autorizzazioneSDD.iban.toUpperCase().trim().slice(0, 27);
				if (!self.raccoltaInfo.autorizzazioneSDD.ibanRadio) {
					self.raccoltaInfo.autorizzazioneSDD.ibanRadio = 'b2b';
				}
				var iban = self.raccoltaInfo.autorizzazioneSDD.iban;
        if(!self.isLo){
          if (checkiban(iban)) {
            self.warnings.iban = false;
            var code = iban.slice(5, 10);
            var bank = self.dropdown.listaBanche.find(function (el) {
              return el.value == code;
            });
          } else {
            self.warnings.iban = true;
            self.raccoltaInfo.autorizzazioneSDD.banca = '';
            self.ibanIsNotOk();
            return;
          }
          if (bank) {
            self.warnings.bank = false;
            self.raccoltaInfo.autorizzazioneSDD.banca = bank;
            $("#select-banca-container .select2").select2();
            self.warnings.newBank = false;
  
            //commento per richiesta mantis n. 0014537
            // if (self.isM14) {
            // 	self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento = self.raccoltaInfo.autorizzazioneSDD;
  
            // 	self.autorizzazione && self.autorizzazione({
            // 		aut: self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento
            // 	});
            // } else {
              self.model.financialCustomer.metadata.autorizzazione = self.raccoltaInfo.autorizzazioneSDD;
  
              self.autorizzazione && self.autorizzazione({
                aut: self.model.financialCustomer.metadata.autorizzazione
              });
            //}
  
            self.ibanIsOk();
          } else {
  
            self.newBank = {
              tableName: 'RI_DROPDOWN_DOMAINS',
              columnName: 'BANKS',
              // name will be added when calling self.insertBank();
              name: '',
              value: code
            };
  
            self.warnings.bank = true;
            self.warnings.newBank = true;
  
            //commento per richiesta mantis n. 0014537
            // if (self.isM14) {
            // 	self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento = self.raccoltaInfo.autorizzazioneSDD;
            // } else {
              self.model.financialCustomer.metadata.autorizzazione = self.raccoltaInfo.autorizzazioneSDD;
            //}
            self.ibanIsOk();
            self.insertBank();
          }
  
          if (self.digital && $portalService.isAra()) {
            callcheckIban(self.raccoltaInfo.autorizzazioneSDD.iban)
          }
        }else{
          //nel caso sia LO
          
          if(checkiban(iban)){
			callcheckIban(iban)
            var code = iban.slice(5, 10);
            var bank = self.dropdown.listaBanche.find(function (el) {
            return el.value == code;
            });
          } else {
            self.warnings.iban = true;
            self.raccoltaInfo.autorizzazioneSDD.banca = '';
            self.ibanIsNotOk();
            return;
          }
          if (bank) {
            self.warnings.bank = false;
            self.raccoltaInfo.autorizzazioneSDD.banca = bank;
            $("#select-banca-container .select2").select2();
            self.warnings.newBank = false;
            self.ibanIsOk();
          } else {
            self.newBank = {
              tableName: "RI_DROPDOWN_DOMAINS",
              columnName: "BANKS",
              // name will be added when calling self.insertBank();
              name: "",
              value: code,
            };

            self.warnings.bank = true;
            self.warnings.newBank = true;
            self.ibanIsOk();
            self.insertBank();
          }
        }
				

			} else {
				self.raccoltaInfo.autorizzazioneSDD.banca = null;
				self.warnings.newBank = false;
			}
		}

		/** This method is called after the FINAL insert Contract **/
		self.insertBank = function () {
			if (self.newBank != null) {
				if(self.raccoltaInfo.autorizzazioneSDD.banca && self.raccoltaInfo.autorizzazioneSDD.banca.name) {
					self.newBank.name = self.raccoltaInfo.autorizzazioneSDD.banca.name;
				}
				console.log("try to add new IBAN bank in the Uni Type Domain... ");
				HttpService.send('/uni/typedomain/insertDomainSet', {
					uniTypeDomain: self.newBank
				}).then(function (response) {});
			}
		}

		self.handleChange = function (name, value) {
			self.raccoltaInfo.autorizzazioneSDD.banca.name = value;
			//callcheckIban(self.raccoltaInfo.autorizzazioneSDD.banca.name);
		}

		var callcheckIban = function (iban) {
			$financialApiService
				.checkIban(iban)
				.then(function (ibanResponse) {
					console.log('product is: ', ibanResponse);
					if (ibanResponse.keyMessage == "LBL_CHECK_IBAN_UNKNOWN" ||
						ibanResponse.keyMessage == "LBL_CHECK_IBAN_ANNULLED"
					) {
						self.ibanIsNotOk();
					} else {
						self.ibanIsOk();
					}
				})
				.catch(function (err) {
					console.log("Errore: ", err);
				})
		}


    
	}
});